import { IconHeart, IconHeartFilled } from "@tabler/icons-react";

type HeartProps = {
  selected?: boolean;
  locked?: boolean;
  size?: number | string;
};

const Heart = ({ selected = false, locked = false, size = 20 }: HeartProps) => {
  if (selected) {
    return <IconHeartFilled size={size} style={{ color: "#1500FF" }} />;
  }

  return (
    <IconHeart
      size={size}
      stroke={locked ? 2 : 2}
      style={{ pointerEvents: locked ? "none" : undefined }}
    />
  );
};

export default Heart;
